import { apiClient } from '@/lib/api-client'

interface VersionResponse {
  version: string
}

export const versionService = {
  async getBackendVersion(): Promise<string> {
    const response = await apiClient.get<VersionResponse>('/api/v1/version')
    return response.version
  }
}
